/**
 * Live evidence normalization for the security advisor.
 * Maps the shop RAG proxy response (/api/chat/completions) into a display model.
 * Contract: hints are supplementary retrieved knowledge for the rule-based catalog
 * proposal. No BoM, SKU list, or price is ever adopted from the answer text.
 */

const MAX_TEXT_CHARS = 1500;
const MAX_SOURCES = 5;

const STATUS_MAP = {
  ok: 'ok',
  grounded: 'ok',
  insufficient_evidence: 'insufficient_evidence',
  escalated: 'escalated',
};

export function normalizeEvidence(body) {
  if (!body || typeof body !== 'object' || body.ok !== true) {
    return { status: 'error', text: '', sources: [] };
  }
  const status = STATUS_MAP[body.status] || 'error';
  const content = String(body.choices?.[0]?.message?.content ?? '')
    .trim()
    .replace(/^#{1,6}[ \t]+/gm, '') // Markdown-Überschriften als Klartext
    .replace(/\*\*/g, '')            // Fett-Marker
    .replace(/\\\*/g, '*')           // escapte Sterne
    .replace(/\*([^*\n]+)\*/g, '$1'); // einfache Hervorhebung
  // Fail-closed: a "positive" status without answer content is not usable evidence.
  if ((status === 'ok' || status === 'escalated') && !content) {
    return { status: 'error', text: '', sources: [] };
  }
  const sources = Array.isArray(body.citations)
    ? body.citations
        .filter((c) => c && typeof c.document_key === 'string' && c.document_key.length > 0)
        .slice(0, MAX_SOURCES)
        .map((c) => ({
          documentKey: c.document_key,
          page: typeof c.page_number === 'number' ? c.page_number : null,
        }))
    : [];
  // ponytail: Wortgrenzen-Kürzung nur bei tatsächlichem Cap (MAX_TEXT_CHARS).
  let text = status === 'error' || !content ? '' : content;
  if (text.length > MAX_TEXT_CHARS) {
    text = text.slice(0, MAX_TEXT_CHARS).replace(/\s+\S*$/, '');
  }
  return {
    status,
    text,
    sources: status === 'ok' ? sources : [],
  };
}
